import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolsWrench = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tools-wrench" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.439,3.9,19.122,7.216H16.784V4.878L20.1,1.561a5.752,5.752,0,0,0-8.168,7L1.589,18.9A2.48,2.48,0,0,0,5.1,22.411L15.44,12.067a5.752,5.752,0,0,0,7-8.168Z"
		})
	]
});
export default SvgToolsWrench;
